/**
 * OnboardingGuard Component
 * Feature: 016-onboarding-conversation
 *
 * Redirects users who have already completed onboarding away from onboarding routes.
 * Prevents users from accessing /onboarding/* routes after completion.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface OnboardingGuardProps {
  children: React.ReactNode;
}

const OnboardingGuard: React.FC<OnboardingGuardProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-100 to-primary-200">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // If user has already completed onboarding, redirect to home
  // (prevents manual URL entry to /onboarding/* after completion)
  if (user?.onboarding?.completed) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default OnboardingGuard;
